/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Severity level of the detection
 * @export
 */
export const ControlSeverity2 = {
    Informational: 'INFORMATIONAL',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type ControlSeverity2 = typeof ControlSeverity2[keyof typeof ControlSeverity2];


export function ControlSeverity2FromJSON(json: any): ControlSeverity2 {
    return ControlSeverity2FromJSONTyped(json, false);
}

export function ControlSeverity2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSeverity2 {
    return json as ControlSeverity2;
}

export function ControlSeverity2ToJSON(value?: ControlSeverity2 | null): any {
    return value as any;
}

